import PropTypes from "prop-types";
import React, { useState } from "react";

import styled from "styled-components/macro";

import API from "Signups/API.js";
import { getSignedUpViaID } from "Signups/SharedComponents/getSignedUpViaID";
import { getSignupErrorMessage } from "Signups/SharedComponents/getSignupErrorMessage";
import { useSignups } from "Signups/state";

import FnrButton from "UI/FnrButton";
import FnrConfirmationPopover from "UI/FnrConfirmationPopover";
import { colors } from "UI/colors";

import { checkForAnyPaidRespondents } from "./utils/checkForAnyPaidRespondents";
import { getUserSignupItem } from "./utils/getUserSignupItem";
import { useIsSignedUpForItem } from "./utils/useIsSignedUpForItem";

CancelItemSignup.propTypes = {
  signupItemID: PropTypes.number,
  closeItem: PropTypes.func,
};

export default function CancelItemSignup({ signupItemID, closeItem }) {
  const [state, dispatch] = useSignups();
  const [status, setStatus] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const triggerRef = React.useRef();
  const userSignupItem = getUserSignupItem(state.userSignupItems, signupItemID);

  const isSignedUp = useIsSignedUpForItem(signupItemID);
  const hasAnyPaidRespondents = checkForAnyPaidRespondents(userSignupItem);

  const toggleShowConfirmation = () => {
    setShowConfirmation(!showConfirmation);
  };

  const handleCancelClick = () => {
    if (status === "loading") return;
    setStatus("loading");

    const signedUpViaID = getSignedUpViaID();
    const emailOrPhone = state.user.emailOrPhone || null;

    API.cancelSignupForItem2({ signupItemID, signedUpViaID, emailOrPhone })
      .post()
      .then((resp) => {
        dispatch({
          type: "Item Signup Updated",
          userSignupItems: resp.userSignupItems,
          newCounts: resp.itemSlotsTaken,
          cancelled: true,
          paymentAmountNeeded: 0,
        });
        dispatch({
          type: "updateSlotsTaken",
          payload: {
            signupItemID,
            slotsTaken: resp.itemSlotsTaken,
          },
        });
        setStatus(null);
        closeItem();
      })
      .catch((err) => {
        alert(getSignupErrorMessage(err.error));
        setStatus(null);
        closeItem();
      });
  };

  if (!isSignedUp || hasAnyPaidRespondents) return <div />;

  return (
    <Wrapper>
      <Button role="button" onClick={toggleShowConfirmation} ref={triggerRef}>
        Cancel My Signup
      </Button>

      <FnrConfirmationPopover
        show={showConfirmation}
        ref={triggerRef}
        onClose={() => setShowConfirmation(false)}
        message="Are you sure you want to cancel this Signup?"
        button1={
          <FnrButton
            text="Yes, cancel it!"
            onClick={handleCancelClick}
            color="red"
            loading={status === "loading"}
          />
        }
        color="red"
        style={{ maxWidth: 200, padding: 10 }}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

const Button = styled.div`
  background-color: transparent;
  border: none;
  font-size: 14px;
  cursor: pointer;
  font-weight: 400;
  text-align: center;
  color: #535353;
  transition: color 200ms;

  &:hover {
    color: ${colors.fnRed};
  }
  &:active {
    transform: translateY(1px);
  }
`;
